<template>
  <div class="Exam-Result-Inner">
        <div class="Result-Header-Main">
          <span>{{Exam.Examination.institution.instcode.toUpperCase() +' EXAM'}} Result</span>
        </div>
        <div class="Result-message">
          <p>Hello <strong>{{Exam.UserFullName}}</strong>,</p>
          <p>Find below the result of your {{Exam.Examination.institution.instcode +' exam'}} ({{Exam.Examination.examcode}} - {{Exam.Examination.shortdescription}}). Taken on {{getExamDate}}.</p>
        </div>
    <div class="Result-message-Body">
    <p><strong>Result Details</strong></p>
    <div class="MobileDevice">
    <table>
        <tr>
            <th id="NameFld"><span>Description</span></th>
            <th id="valuefld"><span>Result</span></th>
        </tr>
        <tr>
            <td id="NameFld"><span>Number of Questions</span></td>
            <td id="valuefld"><span>{{ResultDetails.MainBooking.totalquest}}</span></td>
        </tr>
        <tr>
            <td id="NameFld"><span>Total Correct Answers</span></td>
            <td id="valuefld"><span>{{ResultDetails.MainBooking.totalcorrectanswers}}</span></td>
        </tr>
        <tr>
            <td id="NameFld"><span>Total Score</span></td>
            <td id="valuefld"><span>{{ResultDetails.MainBooking.highestscore}}</span><span v-if="!isMultiple">%</span></td>
        </tr>
        <tr>
            <td id="NameFld"><span>Your Score</span></td>
            <td id="valuefld"><span>{{ResultDetails.MainBooking.totalscore}}</span><span v-if="!isMultiple">%</span></td>
        </tr>
        <tr>
            <td id="NameFld"><span>Pass Mark</span></td>
            <td id="valuefld"><span>{{ResultDetails.MainBooking.passscore}}</span><span v-if="!isMultiple">%</span></td>
        </tr>
        <tr>
            <td id="NameFld"><span>Result Status</span></td>
            <td id="valuefld"><span>{{(ResultDetails.MainBooking.passed) ? 'Pass' : 'Fail'}}</span></td>
        </tr>
     </table>
     <p v-if="isMultiple">*Detail Result will be sent to your email Address</p>
     </div>
    <div class="HigherDevice">
    <table>
        <tr>
            <th id="NameFld"><span>Description</span></th>
            <th v-if="isMultiple" v-for="(hdrec, idx) in ResultDetails.ExamBooking" :key="idx" id="valuefld">
              <span>{{hdrec.examinations.examcode}}</span>
            </th>
            <th id="valuefld"><span>Result</span></th>
        </tr>
        <tr>
            <td id="NameFld"><span>Number of Questions</span></td>
            <td v-if="isMultiple" v-for="(dtrec, idx) in ResultDetails.ExamBooking" :key="idx" id="valuefld">
              <span>{{dtrec.totalquest}}</span>
            </td>
            <td id="valuefld"><span>{{ResultDetails.MainBooking.totalquest}}</span></td>
        </tr>
        <tr>
            <td id="NameFld"><span>Total Correct Answers</span></td>
            <td v-if="isMultiple" v-for="(dtrec, idx) in ResultDetails.ExamBooking" :key="idx" id="valuefld">
              <span>{{dtrec.totalcorrectanswers}}</span>
            </td>
            <td id="valuefld"><span>{{ResultDetails.MainBooking.totalcorrectanswers}}</span></td>
        </tr>
        <tr>
            <td id="NameFld"><span>Total Score</span></td>
            <td v-if="isMultiple" v-for="(dtrec, idx) in ResultDetails.ExamBooking" :key="idx" id="valuefld">
              <span>{{dtrec.highestscore}}%</span>
            </td>
            <td id="valuefld"><span>{{ResultDetails.MainBooking.highestscore}}</span><span v-if="!isMultiple">%</span></td>
        </tr>
        <tr>
            <td id="NameFld"><span>Your Score</span></td>
            <td v-if="isMultiple" v-for="(dtrec, idx) in ResultDetails.ExamBooking" :key="idx" id="valuefld">
              <span>{{dtrec.totalscore}}%</span>
            </td>
            <td id="valuefld"><span>{{ResultDetails.MainBooking.totalscore}}</span><span v-if="!isMultiple">%</span></td>
        </tr>
        <tr>
            <td id="NameFld"><span>Pass Mark</span></td>
            <td v-if="isMultiple" v-for="(dtrec, idx) in ResultDetails.ExamBooking" :key="idx" id="valuefld">
              <span>{{dtrec.passscore}}%</span>
            </td>
            <td id="valuefld"><span>{{ResultDetails.MainBooking.passscore}}</span><span v-if="!isMultiple">%</span></td>
        </tr>
        <tr>
            <td id="NameFld"><span>Result Status</span></td>
            <td v-if="isMultiple" v-for="(dtrec, idx) in ResultDetails.ExamBooking" :key="idx" id="valuefld">
              <span>{{(dtrec.passed)  ? 'Pass' : 'Fail'}}</span>
            </td>
            <td id="valuefld"><span>{{(ResultDetails.MainBooking.passed) ? 'Pass' : 'Fail'}}</span></td>
        </tr>
     </table>
     </div>
    </div>
    <div class="Result-Footer">
      <span>{{(ResultDetails.MainBooking.passed) ? 'Congratulations' : ''}}</span>
    </div>
    </div>
</template>
<script>
var dateformat = require('dateformat')
export default {
  name: 'prepareResult',
  props: ['ResultDetails', 'Exam'],
  data () {
    return {
    }
  },
  computed: {
    getExamDate: function () {
      return dateformat(Date.parse(this.ResultDetails.MainBooking.startdatetime), 'mmmm dS, yyyy')
    },
    isMultiple: function () {
      return this.ResultDetails.ExamBooking.length > 0
    }
  }
}
</script>
<style scoped>
@media screen and (min-width:641px) {
  .MobileDevice {
    display: none;
    visibility: hidden;
  }
  .HigherDevice {
    display: block;
    visibility: visible;
  }
}
.Exam-Result-Inner {
  margin: 10px;
  border: 3px solid lightgrey;
  width: 100%;
  height: 400px;
  font-size: 12px;
}
.Result-message-Body p{
  font-size: 15px;
}
@media screen and (max-width:640px) {
  .MobileDevice {
    display: block;
    visibility: visible;
  }
  .HigherDevice {
    display: none;
    visibility: hidden;
  }
  .Exam-Result-Inner {
    height: 100%;
    margin: 10px;
    border: 3px solid lightgrey;
    width: 100%;
    font-size: 12px;
  }
  .Result-message-Body p{
    font-size: 12px;
  }
}
.Result-Header-Main{
  color: white;
  height: 40px;
  background-color: #317082;
}
.Result-Header-Main span{
  line-height: 40px;
  font-size: 17px;
  vertical-align: middle;
}
.Result-message,
.Result-message-Body {
  margin: 10px;
}
.Result-Footer {
  margin-bottom: 25px;
  margin-top: 25px;
  margin-left: 10px;
  margin-right: 10px;
  background-color: lightblue;
  text-align: center;
}
.Result-Footer span{
  font-size: 25px;
}
p {
  margin-left: 10px;
  margin-right: 10px;
}
span {
  margin-left: 10px;
}
th {
  margin: 10px;
  text-align:left;
  font-size: 13px;
}
td {
  background-color: #eaebed;
  margin: 10px;
  text-align:left;
  height: 20px;
  font-size: 13px;
}
#valuefld {
  width: 150px;
}
#nameFld {
  width: 300px;
}
table, td {
  margin: 10px;
  border: 2px solid white;
  border-collapse: collapse;
}
</style>



// WEBPACK FOOTER //
// src/components/prepareResult.vue